import { GenericMessageTypes } from '@Pages/genericMessagePage/queryParamsSchema';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { IErrorHandling, OnboardingFormFields } from '@Types/index';

export enum KYCStatus {
  CHECKING = 'CHECKING',
  MORE_INFO_REQUIRED = 'MORE_INFO_REQUIRED',
  MORE_INFO_AUTO_REQUIRED = 'MORE_INFO_AUTO_REQUIRED',
  RESUBMIT_REQUIRED = 'RESUBMIT_REQUIRED',
  PARTNER_REVIEW = 'PARTNER_REVIEW',
  RESUBMIT_ADDRESS = 'RESUBMIT_ADDRESS',
  RESUBMIT_ADDRESS_PO_BOX = 'RESUBMIT_ADDRESS_PO_BOX',
  RESUBMIT_ADDRESS_COMMERCIAL = 'RESUBMIT_ADDRESS_COMMERCIAL',
  RESUBMIT_ADDRESS_UNADDRESSABLE = 'RESUBMIT_ADDRESS_UNADDRESSABLE',
  RESUBMIT_ADDRESS_PARTNER = 'RESUBMIT_ADDRESS_PARTNER',
  FAILED = 'FAILED',
}

export const KycErrorMap = {
  [KYCStatus.CHECKING]: 4307,
  [KYCStatus.MORE_INFO_REQUIRED]: 4308,
  [KYCStatus.MORE_INFO_AUTO_REQUIRED]: 4309,
  [KYCStatus.RESUBMIT_REQUIRED]: 4317,
  [KYCStatus.PARTNER_REVIEW]: 4318,
  [KYCStatus.RESUBMIT_ADDRESS]: 43171,
  [KYCStatus.RESUBMIT_ADDRESS_PO_BOX]: 43172,
  [KYCStatus.RESUBMIT_ADDRESS_COMMERCIAL]: 43173,
  [KYCStatus.RESUBMIT_ADDRESS_UNADDRESSABLE]: 43174,
  [KYCStatus.RESUBMIT_ADDRESS_PARTNER]: 43175,
  [KYCStatus.FAILED]: 4017,
};

export const KycErrorsObjectMap = new Map<number, IErrorHandling>([
  [
    KycErrorMap[KYCStatus.FAILED],
    {
      errorCode: KycErrorMap[KYCStatus.FAILED],
      redirectPath: `${routesModel[RoutesMap.GENERIC_MESSAGE_PAGE].path}/?type=${GenericMessageTypes.KYC_FAILED}`,
      relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.CHECKING],
    {
      errorCode: KycErrorMap[KYCStatus.CHECKING],
      redirectPath: `${routesModel[RoutesMap.GENERIC_MESSAGE_PAGE].path}/?type=${GenericMessageTypes.HANG_TIGHT}`,
      relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.MORE_INFO_REQUIRED],
    {
      errorCode: KycErrorMap[KYCStatus.MORE_INFO_REQUIRED],
      redirectPath: routesModel[RoutesMap.SOCURE_DOC_V].path,
      relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.MORE_INFO_AUTO_REQUIRED],
    {
      errorCode: KycErrorMap[KYCStatus.MORE_INFO_AUTO_REQUIRED],
      redirectPath: routesModel[RoutesMap.SOCURE_DOC_V].path,
      relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.RESUBMIT_REQUIRED],
    {
      errorCode: KycErrorMap[KYCStatus.RESUBMIT_REQUIRED],
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.HOME_LINE_1,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.PARTNER_REVIEW],
    {
      errorCode: KycErrorMap[KYCStatus.PARTNER_REVIEW],
      redirectPath: `${routesModel[RoutesMap.GENERIC_MESSAGE_PAGE].path}/?type=${GenericMessageTypes.KYC_FAILED}`,
      relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.RESUBMIT_ADDRESS],
    {
      errorCode: KycErrorMap[KYCStatus.RESUBMIT_ADDRESS],
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.HOME_LINE_1,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_PO_BOX],
    {
      errorCode: KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_PO_BOX],
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.HOME_LINE_1,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_COMMERCIAL],
    {
      errorCode: KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_COMMERCIAL],
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.HOME_LINE_1,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_UNADDRESSABLE],
    {
      errorCode: KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_UNADDRESSABLE],
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.HOME_LINE_1,
      callBack: () => {},
    },
  ],
  [
    KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_PARTNER],
    {
      errorCode: KycErrorMap[KYCStatus.RESUBMIT_ADDRESS_PARTNER],
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.HOME_LINE_1,
      callBack: () => {},
    },
  ],
]);
